var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullseye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 7.75C7.875 8.24219 7.46484 8.625 7 8.625C6.50781 8.625 6.125 8.24219 6.125 7.75C6.125 7.28516 6.50781 6.875 7 6.875C7.46484 6.875 7.875 7.28516 7.875 7.75ZM3.0625 7.75C3.0625 5.58984 4.8125 3.8125 7 3.8125C9.16016 3.8125 10.9375 5.58984 10.9375 7.75C10.9375 9.9375 9.16016 11.6875 7 11.6875C4.8125 11.6875 3.0625 9.9375 3.0625 7.75ZM7 9.9375C8.20312 9.9375 9.1875 8.98047 9.1875 7.75C9.1875 6.54688 8.20312 5.5625 7 5.5625C5.76953 5.5625 4.8125 6.54688 4.8125 7.75C4.8125 8.98047 5.76953 9.9375 7 9.9375ZM14 7.75C14 11.6328 10.8555 14.75 7 14.75C3.11719 14.75 0 11.6328 0 7.75C0 3.89453 3.11719 0.75 7 0.75C10.8555 0.75 14 3.89453 14 7.75ZM7 2.5C4.07422 2.5 1.75 4.85156 1.75 7.75C1.75 10.6484 4.07422 13 7 13C9.89844 13 12.25 10.6484 12.25 7.75C12.25 4.85156 9.89844 2.5 7 2.5Z",
    fill: "#E9EBF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullseye);
export default __webpack_public_path__ + "static/media/bullseye.037f75f0d610bb37520d77b74ca31311.svg";
export { ForwardRef as ReactComponent };